import { CART_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IHDCartOrderCreationFilter, IHDCartOrderCreationResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "../../useConfiguration";
import { setHDCartOrderCreation } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});

type OrderCreateAPIResult =
  | { status: true; data: IHDCartOrderCreationResponse["data"] }
  | { status: false; data: null; message?: string };

export const useOrderCreateAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (filterBody: IHDCartOrderCreationFilter, payment_method: number): Promise<OrderCreateAPIResult> => {
      dispatch(setLoading({ key: "isInventoryProductGoodInventory", status: true }));
      dispatch(setLoading({ key: "isvaccinationTableLoading", status: true }));
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IHDCartOrderCreationResponse> = await axios.post(
          `${CART_MODULE?.HD_CART_ORDER_CREATION?.baseURL}?payment_method_id=${payment_method}`,
          filterBody,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        dispatch(setLoading({ key: "isvaccinationTableLoading", status: false }));
        if (res.data.status) {
          toastNotification(res.data.message);
          dispatch(setHDCartOrderCreation({ data: res.data.data }));
          return { status: true, data: res.data.data };
        } else {
          dispatch(setHDCartOrderCreation({ data: null }));
          return { status: false, data: null, message: res.data.message };
        }
      } catch (e: any) {
        dispatch(setLoading({ key: "isvaccinationTableLoading", status: false }));
        captureError(e);
        if (axios.isAxiosError(e)) {
          sendCurl(e.config?.["curlCommand"]);
        }
        toast.error("Server Error: " + e.message);
        return { status: false, data: null, message: "Server Error" };
      }
    },
    [dispatch],
  );

  return { execute };
};
